<p>EMAIL VERIFICATION CODE</p>
<form
  class="email-verification-code-form"
  [formGroup]="emailVerificationCodeForm"
  (ngSubmit)="onSubmit()"
>
  <label for="emailVerificationCode">Enter code: </label>
  <input id="emailVerificationCode" type="text" formControlName="emailVerificationCode" required />
  <button type="submit">Submit</button>
</form>